export default "__VITE_ASSET__B_R4OKym__"